import { useTranslation } from "react-i18next"
import CommonUtil from "../../../utils/CommonUtil"
import { useEffect } from "react"

const SharePermission = props => {
    const { t } = useTranslation()

    const postTitle = () => {
        if (CommonUtil.isInApp(navigator.userAgent)) {
            window.ReactNativeWebView.postMessage(t('share_permission'))
        }
    }

    useEffect(() => {
        postTitle()
    }, [])
    return <div className="App">
        <div style={{ width: '100%' }}>
            <div className="bind-device-faq-marginH25">
                <span style={{ fontSize: 16, color: '#000000', marginTop: 15, lineHeight: '22px', fontWeight: '500' }}>{t('share_permission_tip')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 15, lineHeight: '22px' }}>{t('share_permission_faq1')}</span>
                <span style={{ fontSize: 14, color: '#666666', marginTop: 10, lineHeight: '22px' }}>{t('share_permission_faq2')}</span>
            </div>
        </div>
    </div>
}

export default SharePermission